/**
 * @file   : ContactUs.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 1/29/2019, 12:18:14 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Cont from '../../external/components/layout/Cont'
import MetaData from '../../external/components/meta/MetaData'
import {
  hackIsMobile,
  isEmpty,
  isUndefined,
} from '../../external/utilities/GeneralUtils'
import { PROTOCOL, openSpecialProtocolPath } from '../../router/RouteManager'
import { getLiteralValuesForApp } from '../../utilities/MetaDataUtils'
import ContactUsLayout from './ContactUsLayout'

export const CHANNEL_WEB = 'WEB'
export const CHANNEL_SMS = 'SMS'
export const CHANNEL_PHONE = 'PHONE'

const SEARCH_TYPE_CLIENT_NAME = 'clientName'
const SEARCH_TYPE_COUNTRY_NAME = 'countryName'
const SEARCH_TYPE_STATE_NAME = 'stateName'
const PAGE_ID = 'PAGE_CONTACT_US'

class ContactUsContainer extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      selectedClients: ContactUsContainer.getAllClients(props.clientConfig),
      searchCritera: [],
      clientSearchResults: [],
      selectedSearchTerm: '',
      contactModalOpen: false,
      selectedClient: {},
      selectedClientChannel: {},
    }
  }

  componentDidUpdate(prevProps) {
    const { clientConfig } = this.props

    if (clientConfig !== prevProps.clientConfig) {
      this.setState({
        selectedClients: ContactUsContainer.getAllClients(clientConfig),
      })
    }
  }

  onSelectClientChannelRequest(selectedClient, selectedClientChannel) {
    if (
      hackIsMobile() &&
      (selectedClientChannel.type === CHANNEL_SMS ||
        selectedClientChannel.type === CHANNEL_PHONE)
    ) {
      if (selectedClientChannel.type === CHANNEL_SMS) {
        openSpecialProtocolPath(PROTOCOL.sms, selectedClientChannel.identifier)
      }

      if (selectedClientChannel.type === CHANNEL_PHONE) {
        openSpecialProtocolPath(
          PROTOCOL.phone,
          selectedClientChannel.identifier,
        )
      }
    } else {
      this.setState({
        ...this.state,
        contactModalOpen: true,
        selectedClient,
        selectedClientChannel,
      })
    }
  }

  onContactModalCloseRequest() {
    this.setState({
      ...this.state,
      contactModalOpen: false,
      selectedClient: {},
      selectedClientChannel: {},
    })
  }

  // ****************search handlers********************************
  onSearchTermChange(searchTerm) {
    this.setState({
      ...this.state,
      clientSearchResults: this.getMatchingSearchCriteria(searchTerm),
    })
  }

  onSearchResultItemSelectRequest(selectedItem) {
    const searchCritera = []
    this.setState({
      ...this.state,
      selectedClients: this.updateSelectedClients([selectedItem]),
      searchCritera,
      selectedSearchTerm: selectedItem.name,
    })
  }

  onSearchTrigger(selectedSearchTerm, selectedItem) {
    const { clientConfig } = this.props
    let searchCritera = []
    let selectedClients = ContactUsContainer.getAllClients(clientConfig)
    let currSelectedSearchTerm = ''
    if (!isEmpty(selectedItem)) {
      selectedClients = this.updateSelectedClients([selectedItem])
      currSelectedSearchTerm = selectedItem.name
    } else if (!isEmpty(selectedSearchTerm)) {
      searchCritera = this.getMatchingSearchCriteria(selectedSearchTerm)
      selectedClients = this.updateSelectedClients(searchCritera)
      currSelectedSearchTerm = selectedSearchTerm
    }

    this.setState({
      ...this.state,
      selectedClients,
      searchCritera,
      selectedSearchTerm: currSelectedSearchTerm,
    })
  }

  onClearSearchRequest() {
    const { clientConfig } = this.props
    this.setState({
      ...this.state,
      selectedClients: ContactUsContainer.getAllClients(clientConfig),
      selectedSearchTerm: '',
    })
  }

  // ****************search helper methods********************************
  updateSelectedClients(selectedItems) {
    const { clientConfig } = this.props
    const selectedClients = []
    if (!isUndefined(clientConfig.clients) && !isEmpty(clientConfig.clients)) {
      if (!isUndefined(selectedItems) && !isEmpty(selectedItems)) {
        for (const item of selectedItems) {
          for (const client of clientConfig.clients) {
            if (item.type === SEARCH_TYPE_CLIENT_NAME) {
              if (
                !isUndefined(client.name) &&
                client.name.toLowerCase().startsWith(item.name.toLowerCase())
              ) {
                ContactUsContainer.addToSelectedClients(selectedClients, client)
              }
            } else if (
              !isUndefined(client.presence) &&
              !isEmpty(client.presence)
            ) {
              for (const presence of client.presence) {
                if (presence.countryCode === item.countryCode) {
                  if (item.type === SEARCH_TYPE_COUNTRY_NAME) {
                    ContactUsContainer.addToSelectedClients(
                      selectedClients,
                      client,
                    )
                  } else if (item.type === SEARCH_TYPE_STATE_NAME) {
                    if (
                      isEmpty(presence.stateCodes) ||
                      presence.stateCodes.indexOf(item.stateCode) > -1
                    ) {
                      ContactUsContainer.addToSelectedClients(
                        selectedClients,
                        client,
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return selectedClients
  }

  getMatchingSearchCriteria(searchTerm) {
    const { clientConfig } = this.props
    const results = []
    if (
      !isEmpty(searchTerm) &&
      !isUndefined(clientConfig.clients) &&
      !isEmpty(clientConfig.clients)
    ) {
      for (const client of clientConfig.clients) {
        if (
          !isUndefined(client.name) &&
          client.name.toLowerCase().startsWith(searchTerm.toLowerCase())
        ) {
          const result = {
            name: client.name,
            type: SEARCH_TYPE_CLIENT_NAME,
          }

          results.push(result)
        }
      }

      if (
        !isUndefined(clientConfig.countries) &&
        !isEmpty(clientConfig.countries)
      ) {
        for (const country of clientConfig.countries) {
          if (
            country.countryName
              .toLowerCase()
              .startsWith(searchTerm.toLowerCase()) ||
            country.countryCode
              .toLowerCase()
              .startsWith(searchTerm.toLowerCase())
          ) {
            const result = {
              name: country.countryName,
              type: SEARCH_TYPE_COUNTRY_NAME,
              countryCode: country.countryCode,
            }

            results.push(result)
          }

          if (!isUndefined(country.states) && !isEmpty(country.states)) {
            for (const state of country.states) {
              if (
                state.stateName
                  .toLowerCase()
                  .startsWith(searchTerm.toLowerCase()) ||
                state.stateCode
                  .toLowerCase()
                  .startsWith(searchTerm.toLowerCase())
              ) {
                const result = {
                  name: state.stateName,
                  type: SEARCH_TYPE_STATE_NAME,
                  countryCode: country.countryCode,
                  stateCode: state.stateCode,
                }

                results.push(result)
              }
            }
          }
        }
      }
    }

    return results
  }

  // ****************static methods********************************
  static getAllClients(clientConfig) {
    if (isUndefined(clientConfig.clients)) {
      return []
    }

    return clientConfig.clients
  }

  static addToSelectedClients(selectedClients, client) {
    let added = false
    if (!isUndefined(selectedClients)) {
      for (const currClient of selectedClients) {
        if (currClient.name === client.name) {
          added = true
          break
        }
      }
      if (!added) {
        selectedClients.push(client)
      }
    }
  }

  render() {
    const { theme, intl, mainConfig, metaConfig } = this.props

    return (
      <Cont>
        <MetaData
          intlObj={intl}
          literalValues={getLiteralValuesForApp(mainConfig)}
          data={metaConfig}
          pageId={PAGE_ID}
        />
        <ContactUsLayout
          theme={theme}
          intl={intl}
          selectedClients={this.state.selectedClients}
          searchCritera={this.state.searchCritera}
          clientSearchResults={this.state.clientSearchResults}
          selectedSearchTerm={this.state.selectedSearchTerm}
          onSearchTrigger={this.onSearchTrigger.bind(this)}
          onSearchTermChange={this.onSearchTermChange.bind(this)}
          onSearchResultItemSelectRequest={this.onSearchResultItemSelectRequest.bind(
            this,
          )}
          onClearSearchRequest={this.onClearSearchRequest.bind(this)}
          mainConfig={mainConfig}
          onSelectClientChannelRequest={this.onSelectClientChannelRequest.bind(
            this,
          )}
          onContactModalCloseRequest={this.onContactModalCloseRequest.bind(
            this,
          )}
          contactModalOpen={this.state.contactModalOpen}
          selectedClient={this.state.selectedClient}
          selectedClientChannel={this.state.selectedClientChannel}
        />
      </Cont>
    )
  }

  static propTypes = {
    theme: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    clientConfig: PropTypes.object.isRequired,
    mainConfig: PropTypes.object.isRequired,
    metaConfig: PropTypes.object.isRequired,
  }
}

const mapStateToProps = function (state) {
  return {
    theme: state.application.theme,
    intl: state.backend.intl,
    clientConfig: state.backend.config.client,
    mainConfig: state.backend.config.main,
    metaConfig: state.backend.config.meta,
  }
}

const mapDispatchToProps = function () {
  return {
    test: () => {},
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsContainer)
